<template>
  <div class="row mt-2">
    <!-- Top merchants -->
    <div class="col-md-6 mb-4">
      <div class="admin-card">
        <div class="card-body p-3">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0 font-weight-bold" style="color:#0f172a;">
              <i class="bi bi-trophy-fill text-dark mr-1"></i> Top Merchants
            </h6>
            <small class="text-secondary">Last 30 days · by orders</small>
          </div>
          <div v-if="loading" class="text-center py-3">
            <div class="spinner-border spinner-border-sm text-secondary"></div>
          </div>
          <div v-else-if="top.length === 0" class="text-center text-secondary py-3">
            <small>No order data yet</small>
          </div>
          <div v-else>
            <div
              v-for="(merchant, i) in top"
              :key="merchant.company_id"
              class="d-flex align-items-center py-2 border-bottom"
              style="font-size:.85rem;"
            >
              <span
                class="font-weight-bold mr-3 text-center"
                :class="i === 0 ? 'text-dark' : 'text-secondary'"
                style="width:20px;flex-shrink:0;"
              >{{ i + 1 }}</span>
              <div class="flex-grow-1 text-truncate">
                <span class="font-weight-bold">{{ merchant.name }}</span>
              </div>
              <div class="text-right ml-2" style="flex-shrink:0;">
                <div class="font-weight-bold text-primary">{{ merchant.order_count.toLocaleString() }} orders</div>
                <small v-if="canViewRevenue" class="text-secondary">KES {{ Math.round(merchant.revenue).toLocaleString() }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Underperforming merchants -->
    <div class="col-md-6 mb-4">
      <div class="admin-card">
        <div class="card-body p-3">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0 font-weight-bold" style="color:#0f172a;">
              <i class="bi bi-arrow-down-circle-fill text-danger mr-1"></i> Underperforming
            </h6>
            <small class="text-secondary">Lowest order volume</small>
          </div>
          <div v-if="loading" class="text-center py-3">
            <div class="spinner-border spinner-border-sm text-secondary"></div>
          </div>
          <div v-else-if="bottom.length === 0" class="text-center text-secondary py-3">
            <small>Not enough data</small>
          </div>
          <div v-else>
            <div
              v-for="merchant in bottom"
              :key="merchant.company_id"
              class="d-flex align-items-center py-2 border-bottom"
              style="font-size:.85rem;"
            >
              <div class="flex-grow-1 text-truncate">
                <span class="font-weight-bold">{{ merchant.name }}</span>
              </div>
              <div class="text-right ml-2" style="flex-shrink:0;">
                <span class="badge badge-light border text-secondary">
                  {{ merchant.order_count }} orders
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AdminMerchantsPanel',

  props: {
    canViewRevenue: { type: Boolean, default: false },
  },

  data() {
    return {
      loading: false,
      top: [],
      bottom: [],
    };
  },

  mounted() {
    this.fetch();
  },

  methods: {
    async fetch() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/admin/merchant-rankings');
        this.top    = data.top    || [];
        this.bottom = data.bottom || [];
      } finally {
        this.loading = false;
      }
    },

    refresh() {
      this.fetch();
    },
  },
};
</script>

<style scoped>
.admin-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 14px;
}
</style>
